import { useContainer } from '../useContainer';
import { GlobalApi } from '../../util/Global';
import { useEffect } from 'react';

export const useScrollListener = (handleScroll: () => void) => {
    const globalApi = useContainer(GlobalApi);

    useEffect(() => {
        globalApi.addEventListener('scroll', handleScroll);

        return () => globalApi.removeEventListener('scroll', handleScroll);
    }, []);
};
